export default __webpack_public_path__ + "static/spot-thyroid__core-360-free-01-1f974b0443418149927e3b88694da3ab.jpg";